<div class="btn-toolbar" role="toolbar" aria-label="Toolbar">
    <div class="btn-group" [hidden]="!searchService.haveRecords || !sortAction" [sq-action-buttons]="{items: sortAction? [sortAction] : [], style: style + ' no-shadow', autoAdjust: true, rightAligned: rightAligned, size: size}"></div>
</div>